<template lang='pug'>
div
    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title Transformer Parts for Window-Type UHF PD Sensors
            //- h2.notopmargin BSS offers a range of sensors suitable for measurements of partial discharges in transformers in the ultra-high frequency range, for installation into new transformers or for retrofits.

        router-link.section(to="/en/products/transformerparts/dielectric-window-set")
            .column-container
                .column
                    .producttitle Dielectric Window Set
                    .subtitle Oil Barrier for Window-Type PD Sensors
                    ul
                        li For oil-filled transformers
                        li Made from PEEK: High-performance polymer with excellent mechanical and chemical resistance up to high temperatures
                
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/dielectric_window_set.webp')
                        img( src='@/assets/photos/product_shots/dielectric_window_set.png', width="100%", alt='BSS Dielectric-Window-Set', title='BSS Dielectric-Window-Set')

        router-link.section(to="/en/products/transformerparts/welding-ring-set")
            .column-container
                .column
                    .producttitle Welding Ring Set
                    .subtitle Mounting Flange for Window-Type PD Sensors
                    ul
                        li Mounting flange for dielectric window and window-type PD sensors
                        li For mounting in tank wall of oil-filled transformers
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/Welding_Ring_Set.webp')
                        img( src='@/assets/photos/product_shots/Welding_Ring_Set.png')

    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title Transformatorteile für UHF-TE-Fenstersensoren
            //- h2.notopmargin BSS offers a range of sensors suitable for measurements of partial discharges in transformers in the ultra-high frequency range, for installation into new transformers or for retrofits.

        router-link.section(to="/de/products/transformerparts/dielectric-window-set")
            .column-container
                .column
                    .producttitle Dielektrisches Fenster Set
                    .subtitle Ölbarriere für UHF-Fenstersensoren
                    ul
                        li Für ölgefüllte Transformatoren
                        li Entwickelt für die Montage in der Kesselwand von Transformatoren mit unserem Anschweißflansch
            
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/dielectric_window_set.webp')
                        img( src='@/assets/photos/product_shots/dielectric_window_set.png', width="100%", alt='BSS Dielectric-Window-Set', title='BSS Dielectric-Window-Set')

        router-link.section(to="/de/products/transformerparts/welding-ring-set")
            .column-container
                .column
                    .producttitle Anschweißflansch Set
                    .subtitle Anschweißflansch für UHF-Fenstersensoren
                    ul
                        li Zur Montage von unserem dielektrischen Fenster und UHF-Fenstersensoren in der Kesselwand von ölgefüllten Transformatoren
                        li Aus rostfreiem Edelstahl gefertigt
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/Welding_Ring_Set.webp')
                        img( src='@/assets/photos/product_shots/Welding_Ring_Set.png')
    
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Transformatorteile",
            description:
                "BSS Transformatorteile für UHF-TE-Fenstersensoren",
        },
        en: {
            title: "BSS | Transformer Parts",
            description:
                "Transformer Parts for Window-Type UHF PD Sensors",
        },
    },
};
</script>

<style lang='sass' scoped>
@import '@/assets/sass/product_overview.sass'
</style>